import axios from 'axios';
import { WireguardConf } from "../../components/vpn/vpn";

const getWireguardConf = async (): Promise<WireguardConf[]> => {
    const res = await axios.get<WireguardConf[]>(`/pcnt/wireguard_conf/`);
    return res.data;
};

const postWireguardConf = async (data: WireguardConf): Promise<WireguardConf> => {
    const { id, row_hash, ...postData } = data;
    const res = await axios.post('/pcnt/wireguard_conf/', postData);
    if (res.status === 201) {
        return res.data; 
    }
    return {} as WireguardConf;
}

const putWireguardConf = async (data: WireguardConf): Promise<WireguardConf> => {
    const { row_hash, ...putData } = data;
    const res = await axios.put<WireguardConf>(`/pcnt/wireguard_conf/${data.id}/`, putData);
    return res.status === 200 ? data : {} as WireguardConf;
}

const deleteWireguardConf = async (id: number, ): Promise<void> => {
    await axios.delete<WireguardConf>(`/pcnt/wireguard_conf/${id}/`);
}

export const api = {
    getWireguardConf,
    putWireguardConf,
    postWireguardConf,
    deleteWireguardConf,
};